import { render, staticRenderFns } from "./CarrerEdit.vue?vue&type=template&id=ccae0530"
import script from "./CarrerEdit.vue?vue&type=script&lang=js"
export * from "./CarrerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports